import React, { useState, useRef } from "react";
import "./Footer.css";
import { Nav, NavLink } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faLocationDot,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  faFacebookF,
  faInstagramSquare,
  faLinkedinIn,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
  const [serviceoffcanvasShow, setServiceOffcanvasShow] = useState(false);

  const location = useLocation();

  const socialIcons = [
    {
      icon: faLinkedinIn,
      link: "https://www.linkedin.com/company/profcymacareersolutions",
    },
    {
      icon: faFacebookF,
      link: "https://www.facebook.com/ProfcymaCareerSolutions/",
    },
    {
      icon: faInstagramSquare,
      link: "https://www.instagram.com/profcyma_careersolutions/",
    },
    // { icon: faXTwitter, link: "https://twitter.com" },
  ];

  const email = "contact@sdhealthconsultants.com";
  const gmailLink = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}`;

  return (
    <>
      <section className="Footer">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-12 col-sm-12 order-1 mb-3">
              <div className="logo_holder">
                <img
                  src="/assets/images/logo/logo.png"
                  alt="Logo"
                  className="logo_img"
                />
              </div>
            </div>

            <div className="col-lg-2 col-md-3 col-sm-3 col-7 order-2 mb-3">
              <div className="col_div">
                <p className="footer_section_title">Quick Links</p>
                <Nav>
                  <div className="first_nav_div">
                    <Nav.Item>
                      <NavLink
                        as={Link}
                        to="/advantage"
                        className={
                          location.pathname === "/advantage" ? "active" : ""
                        }
                      >
                        Why us
                      </NavLink>
                    </Nav.Item>

                    <Nav.Item>
                      <NavLink
                        as={Link}
                        to="/check-your-fit"
                        className={
                          location.pathname === "/check-your-fFit"
                            ? "active"
                            : ""
                        }
                      >
                        Check Your Earning
                      </NavLink>
                    </Nav.Item>

                    <Nav.Item>
                      <NavLink
                        as={Link}
                        to="/privacy-policy"
                        className={
                          location.pathname === "/privacy-policy"
                            ? "active"
                            : ""
                        }
                      >
                        Privacy Policy
                      </NavLink>
                    </Nav.Item>

                    <Nav.Item>
                      <NavLink
                        as={Link}
                        to="/terms-conditions"
                        className={
                          location.pathname === "/terms-conditions"
                            ? "active"
                            : ""
                        }
                      >
                        Term And Conditions
                      </NavLink>
                    </Nav.Item>
                  </div>
                </Nav>
              </div>
            </div>

            <div className="col-lg-4 col-md-5 col-sm-6  order-sm-3 order-4 mb-3">
              <div className="col_div">
                <p className="footer_section_title">Contact Us</p>

                <div className="footer_info_div">
                  <FontAwesomeIcon icon={faPhone} className="icon_text" />
                  <div className="no_div">
                    <Link to="tel:+91 9860335582">
                      <p className="info_text">1800-267-8961</p>
                    </Link>
                    <Link className="ms-2" to="tel:+91 9860029495">
                      <p className="info_text"> / +91 96077 55557</p>
                    </Link>
                  </div>
                </div>

                <div className="footer_info_div">
                  <FontAwesomeIcon icon={faEnvelope} className="icon_text" />
                  <a
                    href="https://mail.google.com/mail/?view=cm&fs=1&to=inquiry@profcyma.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <p className="info_text">inquiry@profcyma.com</p>
                  </a>
                </div>

                <div className="footer_info_div">
                  <FontAwesomeIcon icon={faLocationDot} className="icon_text" />
                  <p className="info_text">
                    2nd floor, Office No 3, Opp High-Class Soc., M.No. 734 Near
                    Suryadutta College, Bavdhan Khurd, Pune 411021.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-4 col-sm-3 col-5 order-sm-4 order-3 mb-3">
              <div className="col_div">
                <p className="footer_section_title">Follow Us</p>

                <div className="icons_holder">
                  {socialIcons.map((item, index) => (
                    <div className="icon_holder" key={index}>
                      <a
                        href={item.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="link"
                      >
                        <FontAwesomeIcon
                          icon={item.icon}
                          className="icon_class"
                        />
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="footer_text_div">
            <p className="footer_text">
              © 2025 All Rights Reserved Terms Of Use | Privacy Policy Powered
              by{" "}
              <Link to={"https://profcyma.com/"} target="_blank">
                Profcyma
                <div className="img_holder">
                  <img
                    className="logo_img"
                    src="/assets/images/logo/logo.png"
                    alt=""
                  />
                </div>
              </Link>
            </p>
          </div>
        </div>

        <div className="all_ventures_holder">
          <div>
            <Link to={"https://profcyma.com/"} target="_blank">
              <div className="img_holder">
                <img
                  className="logo_img"
                  src="/assets/images/footer/img_1.png"
                  alt=""
                />
              </div>
            </Link>
          </div>

          <div>
            <Link to={"https://profcymaglobal.com/"} target="_blank">
              <div className="img_holder">
                <img
                  className="logo_img"
                  src="/assets/images/footer/img_2.png"
                  alt=""
                />
              </div>
            </Link>
          </div>

          <div>
            <Link to={"https://www.profcymafinance.com/"} target="_blank">
              <div className="img_holder">
                <img
                  className="logo_img"
                  src="/assets/images/footer/img_3.png"
                  alt=""
                />
              </div>
            </Link>
          </div>

          <div>
            <Link to={"https://placementplatform.com/"} target="_blank">
              <div className="img_holder">
                <img
                  className="logo_img"
                  src="/assets/images/footer/img_4.png"
                  alt=""
                />
              </div>
            </Link>
          </div>

          <div>
            <Link to={"https://profcymashikshansanstha.com/"} target="_blank">
              <div className="img_holder">
                <img
                  className="logo_img"
                  src="/assets/images/footer/img_5.png"
                  alt=""
                />
              </div>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Footer;
